import ErrorFallback from 'Components/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import { ProductCreatePage, ProductDetailPage, ProductEditPage, ProductListPage } from './Pages'

function ProductRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ProductListPage />} />
        <Route path="create" element={<ProductCreatePage />} />
        <Route path=":id" element={<ProductDetailPage />} />
        <Route path=":id/edit" element={<ProductEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default ProductRoot
